import { Stack } from '@mui/material';

import { useScrollable } from './useScrollable';

export const ScrollableHeader = ({
  children,
  hideBorderWhenOnTop,
}: React.PropsWithChildren<{
  hideBorderWhenOnTop?: boolean;
}>) => {
  const { isScrolledVertically } = useScrollable();

  return (
    <Stack
      sx={{
        borderBottom: hideBorderWhenOnTop
          ? 'none'
          : '1px solid var(--mui-palette-divider)',
        boxShadow: isScrolledVertically
          ? 'var(--mui-customShadows-panel)'
          : undefined,
      }}
    >
      {children}
    </Stack>
  );
};
